import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FAQ_NAMESPACE } from '../../store/modules/faq/faq.store.js';
import { store } from '../../store/index.js';

var faqModule = namespace(FAQ_NAMESPACE);
/**
 * Component displaying FAQ header containing search field and contact details
 */
var FaqHeaderComponent = /** @class */ (function (_super) {
    __extends(FaqHeaderComponent, _super);
    function FaqHeaderComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchText = _this.value;
        return _this;
    }
    FaqHeaderComponent.prototype.destroyed = function () {
        this.setSearchText('');
    };
    FaqHeaderComponent.prototype.updateSearchText = function () {
        this.setSearchText(this.searchText);
        return this.searchText;
    };
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], FaqHeaderComponent.prototype, "value", void 0);
    __decorate([
        faqModule.Action('setSearchText'),
        __metadata("design:type", Function)
    ], FaqHeaderComponent.prototype, "setSearchText", void 0);
    __decorate([
        Watch('searchText', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FaqHeaderComponent.prototype, "updateSearchText", null);
    FaqHeaderComponent = __decorate([
        Component({
            name: 'faq-header',
            store: store,
        })
    ], FaqHeaderComponent);
    return FaqHeaderComponent;
}(Mixins(MagicConfigMixin)));

export default FaqHeaderComponent;
